import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { EditCoupon } from '../../redux/Slices/CouponSlice';
import notify from './../UseNotification';

const UseAdminEditCoupon = (item) => {
    const DateRef = useRef()
    // convert date from server format to normal format 
    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "numeric", day: "numeric" }
        return new Date(dateString).toLocaleDateString(undefined, options)
    }
    const dispatch = useDispatch();
    let Coupondate = formatDate(item?.expire)
    const [Editshow, setEditshow] = useState(false)
    const [editLoading, setEditLoading] = useState(true)
    const [isPress, setIsPress] = useState(false)
    const [couponNameEdit, setCouponNameEdit] = useState(item?.name)
    const [couponDateEdit, setCouponDateEdit] = useState(Coupondate)
    const [isFormValid, setIsFormValid] = useState(false)
    const [couponDiscountValueEdit, setCouponDiscountValueEdit] = useState(item?.discount)
    const { editCoupon } = useSelector(state => state.CouponReducer)

    // handle edit close
    const handleEditClose = () => {
        setEditshow(false)
    }

    // handle edit show
    const handleEditShow = () => {
        setEditshow(true)
    }

    // handle change coupon name
    const ChangeEditCouponName = (e) => {
        setCouponNameEdit(e.target.value)
    }

    // handle change coupon date
    const ChangeEditCouponDate = (e) => {
        setCouponDateEdit(e.target.value)
    }

    // get today date + selected date 
    let todayDate = new Date()
    let selectedDate = new Date(couponDateEdit)

    // validate the coupone name
    const ValidateCouponName = (e) => {
        if (e.target.value.length < 3) {
            notify("coupon name must at least 3 character", "error")
        }
    }

    // validate the coupone value
    const ValidateCouponValue = (e) => {
        if (e.target.value === "") {
            notify("please enter the coupon value", "error")
        }
    }
    // validate the coupone date
    const valiadteCouponDate = (e) => {
        if (e.target.value === "") {
            notify("please enter the coupon expire date", "error")
        } else if (todayDate > selectedDate) {
            notify("Selected date cannot be in the past", "error")
            return;
        }
        else {
            DateRef.current.type = "text"
        }
    }

    // to handle disable submit button
    useEffect(() => {
        if (couponNameEdit && couponDateEdit && couponDiscountValueEdit && couponNameEdit.length >= 3 && couponDiscountValueEdit != "" && couponDateEdit != "") {
            setIsFormValid(true)
        } else {
            setIsFormValid(false)
        }
    }, [couponNameEdit, couponDateEdit, couponDiscountValueEdit])

    // handle change coupon Discount value
    const ChangeEditCouponValue = (e) => {
        setCouponDiscountValueEdit(e.target.value)
    }

    // to run HandleEditCoupon 
    const HandleEditCoupon = async () => {
        setIsPress(true)
        if (couponNameEdit === "") {
            notify("enter the coupon name", "error")
            return;
        }
        else if (couponDateEdit === "") {
            notify("enter the expire date", "error")
            return;
        }
        else if (couponDiscountValueEdit === "") {
            notify("enter the coupon discount value", "error")
            return;
        }
        else if (todayDate > selectedDate) {
            notify("Selected date cannot be in the past", "error")
            return;
        }
        setTimeout(() => {
            handleEditClose();
        }, 1000)
        setEditLoading(true);
        await dispatch(EditCoupon({
            id: item._id,
            data: {
                name: couponNameEdit,
                expire: couponDateEdit,
                discount: couponDiscountValueEdit
            }
        }));
        setEditLoading(false);
    }

    // to handle request response
    useEffect(() => {
        if (editLoading === false) {
            setIsPress(false)
            if (editCoupon && editCoupon.data) {
                notify("Coupon Edited", "success")
                window.location.reload(false)
            }
            else if (editCoupon && editCoupon.response.status === 500) {
                if (editCoupon.response.data.error.errors.name) {
                    notify(editCoupon.response.data.error.errors.name.message, "error")
                } else if (editCoupon.response.data.error.errors.discount) {
                    notify(editCoupon.response.data.error.errors.discount.message, "error")
                }
            }

        }
    }, [editLoading])


    return [isFormValid, editLoading, isPress, DateRef, ValidateCouponName, ValidateCouponValue, valiadteCouponDate, formatDate, Editshow, couponNameEdit, ChangeEditCouponName, couponDateEdit, ChangeEditCouponDate, couponDiscountValueEdit, ChangeEditCouponValue, handleEditClose, handleEditShow, HandleEditCoupon]

}

export default UseAdminEditCoupon
